import { graphql } from "~/gql";

export const CREATE_LIBRARY_TECHNOLOGY = graphql(/* GraphQL */ `
  mutation CreateLibraryTechnology($data: LibraryTechnologyCreateInput!) {
    createLibraryTechnology(data: $data) {
      ...LibraryTechnologyParts
    }
  }
`);
